import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import RightNav from "~/RightNav";
import Kba from "~/Components/Global/Kba";

// const { state: userState, dispatch } = useUser();
// const loginToggle = () => dispatch({ type: "signin_open" });

// {!userState.loggedin && (
//   <div className="login-wrapper" onClick={() => loginToggle()}>
//     Login
//   </div>
// )}
// {userState.loggedin && userState.user && <div>Welcome, {userState.user.full_name}</div>}

const PageMiddle = ({ withNav = true, children }) =>
  withNav ? (
    <Row>
      <Col xs={12} lg={9} className="main-section">
        <div className="middleWrapper">
          <div className="mainSection">{children}</div>
        </div>
      </Col>
      <Col xs={12} lg={3} className="right-nav">
        <RightNav />
      </Col>
      <Col xs={12}>
        <Kba />
      </Col>
    </Row>
  ) : (
    <Row>
      <Col xs={12} className="main-section">
        <div className="middleWrapper">
          <div className="mainSection">{children}</div>
        </div>
      </Col>
    </Row>
  );

export default PageMiddle;
